import type { SVGProps } from 'react'

/**
 * Document attachment icon component
 * @param props - SVG properties including className, fill, etc.
 */
export function DocumentAttachment(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M10.5 5.69V5.1C10.5 3.99 10.499 3.2 10.414 2.61C10.33 2.02 10.18 1.69 9.91 1.44C9.65 1.19 9.28 1.04 8.65 0.96C8.01 0.88 7.17 0.875 6 0.875H5.38C4.2 0.875 3.36 0.88 2.72 0.96C2.09 1.04 1.73 1.19 1.46 1.44C1.2 1.69 1.04 2.02 0.96 2.61C0.88 3.2 0.88 3.99 0.88 5.1V7.44C0.88 8.55 0.88 9.34 0.96 9.94C1.04 10.52 1.2 10.85 1.46 11.1C1.73 11.354 2.09 11.5 2.72 11.58C3.36 11.67 4.2 11.67 5.38 11.67H5.69C5.93 11.67 6.125 11.86 6.125 12.1C6.125 12.35 5.93 12.54 5.69 12.54H5.38C4.23 12.54 3.32 12.54 2.61 12.45C1.9 12.36 1.32 12.17 0.86 11.739C0.4 11.3 0.19 10.75 0.09 10.06C0 9.39 0 8.52 0 7.44V5.1C0 4.02 0 3.16 0.09 2.48C0.19 1.79 0.4 1.24 0.86 0.8C1.32 0.37 1.9 0.18 2.61 0.09C3.32 0 4.23 0 5.38 0H6C7.15 0 8.06 0 8.76 0.09C9.48 0.18 10.06 0.37 10.51 0.8C10.98 1.24 11.18 1.79 11.28 2.48C11.38 3.16 11.375 4.02 11.375 5.1V5.69C11.375 5.93 11.18 6.125 10.94 6.125C10.7 6.125 10.5 5.93 10.5 5.69Z'
        fill='currentColor'
      />
      <path
        d='M8.02 2.92C8.26 2.92 8.46 3.11 8.46 3.35C8.46 3.6 8.26 3.79 8.02 3.79H3.354C3.11 3.79 2.92 3.6 2.92 3.35C2.92 3.11 3.11 2.92 3.354 2.92H8.02Z'
        fill='currentColor'
      />
      <path
        d='M6.27 5.83C6.51 5.83 6.71 6.03 6.71 6.27C6.71 6.51 6.51 6.71 6.27 6.71H3.354C3.11 6.71 2.92 6.51 2.92 6.27C2.92 6.03 3.11 5.83 3.354 5.83H6.27Z'
        fill='currentColor'
      />
      <path
        d='M9.78 11.23L9.78 9.63C9.78 9.39 9.59 9.2 9.35 9.2C9.1 9.2 8.91 9.39 8.91 9.63L8.91 11.23C8.91 11.416 8.7 11.67 8.39 11.67C8.08 11.67 7.875 11.42 7.875 11.23L7.875 9.19C7.875 8.9 8.01 8.57 8.27 8.3C8.52 8.04 8.846 7.875 9.19 7.875C9.529 7.875 9.86 8.04 10.11 8.3C10.36 8.57 10.5 8.9 10.5 9.19L10.5 11.32C10.5 11.56 10.696 11.75 10.94 11.75C11.179 11.75 11.37 11.56 11.375 11.32L11.375 9.19C11.375 8.64 11.12 8.1 10.74 7.7C10.36 7.3 9.81 7 9.19 7C8.56 7 8.02 7.3 7.63 7.7C7.25 8.1 7 8.64 7 9.19L7 11.23C7 11.95 7.65 12.54 8.39 12.54C9.13 12.54 9.78 11.95 9.78 11.23Z'
        fill='currentColor'
      />
    </svg>
  )
}
